module.exports = __webpack_public_path__ + "static/media/StrengthM.b972cccb.png";